import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import { printers as printersApi } from '@afosto/spooler/api/Printers';
import translations from './translations';

const PrinterDialog = ({ isOpen, onSelect, onCancel }) => {
  const [printers, setPrinters] = useState([]);
  const [isFetchingPrinters, setIsFetchingPrinters] = useState(true);

  useEffect(() => {
    const fetchPrinters = async () => {
      setIsFetchingPrinters(true);

      try {
        const response = await printersApi.listPrinters();
        const { data = [] } = response;

        setPrinters(data);
      } catch (err) {
        setPrinters([]);
      } finally {
        setIsFetchingPrinters(false);
      }
    };

    if (isOpen) {
      fetchPrinters();
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} maxWidth="xs">
      <DialogTitle>
        <FormattedMessage {...translations.printerDialog.title} />
      </DialogTitle>
      <LoadingWrapper isLoading={isFetchingPrinters}>
        <List style={{ minWidth: 300 }} disablePadding>
          {printers.length > 0 && <Divider />}
          {printers.map(printer => (
            <ListItem key={printer.id} onClick={() => onSelect(printer)} button divider>
              <ListItemText primary={printer.name} />
            </ListItem>
          ))}
        </List>
      </LoadingWrapper>
      <DialogActions>
        <Box display="flex" width="100%" justifyContent="start">
          <Button variant="outlined" onClick={onCancel}>
            <FormattedMessage {...translations.printerDialog.actions.cancel} />
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

PrinterDialog.propTypes = {
  isOpen: PropTypes.bool,
  onSelect: PropTypes.func,
  onCancel: PropTypes.func,
};

PrinterDialog.defaultProps = {
  isOpen: false,
  onSelect: undefined,
  onCancel: undefined,
};

export default PrinterDialog;
